import dayjs from "dayjs";
import TourLikeButton from "components/tour/TourLikeButton";

export const isAlwaysTour = (t) => t.tour_type === "ALWAYS";

export const isDepartureConfirmed = (t) => {
    if (isAlwaysTour(t)) {
        return (t.departures_summary || []).some(
            (d) => (d.confirmed_count ?? 0) >= (d.min_participants ?? d.capacity ?? Infinity)
        );
    }
    if (!t.min_participants) return false;
    return (t.confirmed_count ?? 0) >= t.min_participants;
};

const fmtPeriod = (t) => {
    if (isAlwaysTour(t)) return null;
    if (!t.start_date) return "일정 미정";
    const s = dayjs(t.start_date);
    if (!t.end_date || t.end_date === t.start_date) return s.format("YY.MM.DD");
    const e = dayjs(t.end_date);

    return  `${s.format("YY.MM.DD")}~${e.format("MM.DD")}`;
};

const guideLabel = (guides = []) => {
    if (!guides.length) return null;

    return guides.join("&");
};

/**
 * 투어 목록 카드. `.tour-page .package-grid` 안에서 사용한다 (tourPage.scss).
 * liked / onLikeClick 을 넘기면 이미지 우하단에 찜 하트를 노출한다.
 */
const TourCard = ({ tour: t, onClick, liked, onLikeClick }) => {
    const always = isAlwaysTour(t);
    const confirmed = isDepartureConfirmed(t);
    const hasImage = Boolean(t.thumbnail_image);
    const hasDiscount =
        t.discount_price &&
        Number(t.discount_price) > 0 &&
        Number(t.discount_price) < Number(t.price);
    const guide = guideLabel(t.guide_names);
    const max = t.max_participants ?? 0;

    const { remaining_spots } = t;

    return (
        <div
            className="package-card"
            onClick={() => onClick?.(t.id)}
        >
            <div className="package-image">
                {hasImage ? (
                    <img src={t.thumbnail_image} alt={t.name} />
                ) : (
                    <div className="package-image-default">
                        <svg
                            width="36"
                            height="36"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"
                                fill="currentColor"
                            />
                        </svg>
                        <span>{t.location || "BUCCL TOUR"}</span>
                    </div>
                )}

                {(always || confirmed) && (
                    <div className="package-status-badges">
                        {always && (
                            <span className="package-status-badge package-status-badge--always">
                                상시
                            </span>
                        )}
                        {confirmed && (
                            <span className="package-status-badge package-status-badge--confirmed">
                                출발확정
                            </span>
                        )}
                    </div>
                )}

                {onLikeClick && (
                    <TourLikeButton
                        liked={Boolean(liked)}
                        onClick={() => onLikeClick(t.id)}
                    />
                )}
            </div>
            <div className="package-info">
                <h3>{`${t.location} ${t.name}`}</h3>
                <p className="package-meta">{fmtPeriod(t)}</p>
                <p className="package-meta">
                  {!always && max > 0 && (
                      <span >
                        {`잔여 ${remaining_spots}자리 ・ `}
                      </span>
                  )}
                    {guide && (
                    <span className="package-meta">{guide} 인솔</span>
                )}
                </p>
                <p className="package-price">
                    <span className="discount-price">
                        {Number(
                            hasDiscount ? t.discount_price : t.price
                        ).toLocaleString()}
                        원
                    </span>
                    {hasDiscount && (
                        <span className="origin-price">
                            {Number(t.price).toLocaleString()}원
                        </span>
                    )}
                </p>
            </div>
        </div>
    );
};

export default TourCard;
